import React from 'react'
import AdditionalRoundPassive from "./AdditionalRoundPassive";

function Index(
    {
        expanded
    }) {
    return (expanded && <AdditionalRoundPassive />)
}


export default Index;